import Action from '@/models/list/Action';

import { TYPES } from '@/modules/Education/Teach/constants';

import APIService from '@/services/APIService';

export default {
  createJoarnalAnswer(data) {
    return APIService.post('/journal-answers', data);
  },
  getJoarnalAnswer(data) {
    return APIService.get('/journal-answers/', data);
  },
  saveJoarnalAnswer(id, data) {
    return APIService.post(`/journal-answers/${id}/answer`, data);
  },
  getJournalTasks(data) {
    return APIService.get('/journal-tasks/', data);
  },
  getJournalAnswerByGroups(data, params) {
    return APIService.post('/journal-answer/by-groups', data, {
      params: { ...params, expand: 'task,user,group' },
      rOptions: {
        model: Action,
        many: true,
        itemParse: ({
          task, updated_at: date, user, group,
        }) => {
          let course = null;
          let unit = null;
          let lesson = null;
          const subjectType = task.related_morph_tasktable.tasktable_type;
          const instance = task.related_morph_tasktable.tasktable_model;

          if (subjectType === 'lesson') {
            lesson = instance;
            unit = instance.course_unit;
            [course] = instance.course_unit.courses;
          } else if (subjectType === 'course-unit') {
            unit = instance;
            course = instance.course;
          } else {
            course = instance;
          }

          return {
            course,
            unit,
            lesson,
            group,

            task: { id: task.id, title: task.title },
            date,
            user,
            type: TYPES.taskCheck,
          };
        },
      },
    });
  },
};
